module.exports = __webpack_public_path__ + "media/images/edion/top/2-5f77b49ceef464835b10308323914bff.png";